<!-- <div id="loading-wrapper">
	<div id="loading-text">LOADING</div>
	<div id="loading-content"></div>
</div> -->

<div class="d-flex justify-content-between loading-overlay">
	<img class="avatar-xl m-auto" src="/assets/images/loading.svg" alt="Loading..."/>
</div>